import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/common/Navbar';
import Sidebar from './components/common/Sidebar';
import AppRoutes from './routes';
import useAuth from './hooks/useAuth';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Wrapper qui inclut la navigation et la sidebar pour les pages authentifiées
const Layout = ({ children }) => {
  const { isAuthenticated, isFirstLogin } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Ne pas afficher la navigation sur les pages de login et first login
  if (!isAuthenticated || isFirstLogin) {
    return children;
  }

  return (
    <div className="d-flex">
      <Sidebar isOpen={sidebarOpen} />
      <div
        className="content-wrapper"
        style={{
          marginLeft: sidebarOpen ? '250px' : '0',
          width: sidebarOpen ? 'calc(100% - 250px)' : '100%',
          transition: 'margin-left 0.3s ease, width 0.3s ease',
        }}
      >
        <Navbar toggleSidebar={toggleSidebar} />
        <main className="p-4">
          {children}
        </main>
      </div>
    </div>
  );
};

// Composant App principal
const App = () => {
  return (
    <Router basename="/senoscar">
      <AuthProvider>
        <Layout>
          <AppRoutes />
          <ToastContainer position="top-right" autoClose={5000} />
        </Layout>
      </AuthProvider>
    </Router>
  );
};

export default App;